import axios from "axios";
import { MEMBER_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeader = () => {
  const t = localStorage.getItem(MEMBER_TOKEN_KEY);
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const galleryApi = {
  getConsent: async () => (await axios.get(`${API}/member/gallery/consent`, { headers: authHeader() })).data,
  grantConsent: async () => (await axios.post(`${API}/member/gallery/consent`, { consented: true }, { headers: authHeader() })).data,
  withdrawConsent: async () => (await axios.post(`${API}/member/gallery/consent/withdraw`, {}, { headers: authHeader() })).data,
  getSelfie: async () => (await axios.get(`${API}/member/gallery/selfie`, { headers: authHeader() })).data,
  uploadSelfie: async (file) => {
    const fd = new FormData();
    fd.append("selfie", file);
    return (await axios.post(`${API}/member/gallery/selfie`, fd, {
      headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    })).data;
  },
  deleteSelfie: async () => (await axios.delete(`${API}/member/gallery/selfie`, { headers: authHeader() })).data,
  count: async () => (await axios.get(`${API}/member/gallery/count`, { headers: authHeader() })).data,
  myPhotos: async ({ limit = 50, cursor } = {}) => {
    const p = new URLSearchParams(); p.set("limit", limit); if (cursor) p.set("cursor", cursor);
    return (await axios.get(`${API}/member/gallery/my-photos?${p}`, { headers: authHeader() })).data;
  },
  selfiePreviewUrl: () => `${API}/member/gallery/selfie/preview`,
};

export const galleryApiErr = (e) => e?.response?.data?.detail?.errors?.[0]?.message
  || e?.response?.data?.detail
  || e?.message
  || "Something went wrong";
